import styled from "@emotion/styled"
import {
  ButtonWithIcon,
  InputWrapper,
  Button
} from "../../../styles/common.styled"
import { AccordionButton } from "@chakra-ui/react"

import type { RoomBranding } from "../../../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles: RoomBranding
  isSmallWindowHeight?: boolean
}

export const LinksList = styled.div`
  overflow: auto;
`

export const LinksInputWrapper = styled(InputWrapper)`
  margin-bottom: 0.4rem;
`

export const LinksRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const CloseButton = styled(ButtonWithIcon)`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1;
`
export const DropdownButton = styled(AccordionButton)<StylesProps>`
  border-radius: 0.375rem;
  padding: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.3rem 0.75rem" : "0.375rem 0.75rem"};
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.9rem" : "1rem"};
  cursor: pointer;
  margin-bottom: 1rem;
  width: 100%;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${({ roomStyles }) =>
    roomStyles?.secondaryAccessButtonBorderColor
      ? `1px solid ${
          roomStyles?.secondaryAccessButtonBorderColor
            ? roomStyles.secondaryAccessButtonBorderColor
            : "transparent"
        }`
      : "0px"};
  background-color: ${({ roomStyles }) =>
    roomStyles.secondaryAccessButtonBackgroundColor || "#fff"};
  color: ${({ roomStyles }) =>
    roomStyles.secondaryAccessButtonTextColor || "#fff"};
  &:hover {
    background-color: ${({ roomStyles }) =>
      roomStyles.secondaryAccessButtonMouseoverColor || "#fff"};
    color: ${({ roomStyles }) =>
      roomStyles.secondaryAccessButtonTextMouseoverColor || "#fff"};
  }
  &:disabled {
    opacity: 1;
    cursor: not-allowed;
    background-color: ${({ roomStyles }) =>
      roomStyles?.closeButtonBackgroundColor
        ? roomStyles?.closeButtonBackgroundColor
        : "#FF0000"};
    border: ${({ roomStyles }) =>
      roomStyles?.closeButtonBorderColor
        ? `1px solid ${
            roomStyles?.closeButtonBorderColor
              ? roomStyles.closeButtonBorderColor
              : "transparent"
          }`
        : "0px"};
    color: ${({ roomStyles }) =>
      roomStyles?.joinPageButtonTextColor
        ? roomStyles?.joinPageButtonTextColor
        : "#FFFFFF"};
    pointer-events: none;
    user-select: none;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const CoWatchButton = styled(Button)`
  margin-bottom: 0.4rem;
`
